/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddAbsenceWhitelistEntryResponse } from '../model/addAbsenceWhitelistEntryResponse';
import { AddWhitelistEntryResponse } from '../model/addWhitelistEntryResponse';
import { BlacklistEntry } from '../model/blacklistEntry';
import { DeleteWhitelistEntryResponse } from '../model/deleteWhitelistEntryResponse';
import { DisplayNumber } from '../model/displayNumber';
import { GetAbsenceActivatedForMobile } from '../model/getAbsenceActivatedForMobile';
import { GetAbsenceSubscriptionResponse } from '../model/getAbsenceSubscriptionResponse';
import { GetAbsenceWhitelistResponse } from '../model/getAbsenceWhitelistResponse';
import { GetAcdGroupNumberNumberResponse } from '../model/getAcdGroupNumberNumberResponse';
import { GetActiveProfileLeisureResponse } from '../model/getActiveProfileLeisureResponse';
import { GetActiveProfileResponse } from '../model/getActiveProfileResponse';
import { GetBlacklistResponse } from '../model/getBlacklistResponse';
import { GetBlockedStatusResponse } from '../model/getBlockedStatusResponse';
import { GetCallbackEnabledResponse } from '../model/getCallbackEnabledResponse';
import { GetColleagueNumberResponse } from '../model/getColleagueNumberResponse';
import { GetCompanyDisplayNumberFollowsLoginResponse } from '../model/getCompanyDisplayNumberFollowsLoginResponse';
import { GetCompanyDisplayNumberFollowsTimeRoutingResponse } from '../model/getCompanyDisplayNumberFollowsTimeRoutingResponse';
import { GetCompanyDisplayNumberInternalResponse } from '../model/getCompanyDisplayNumberInternalResponse';
import { GetCompanyDisplayNumberResponse } from '../model/getCompanyDisplayNumberResponse';
import { GetDisplayNumberAfterWorkHoursResponse } from '../model/getDisplayNumberAfterWorkHoursResponse';
import { GetDisplayNumberResponse } from '../model/getDisplayNumberResponse';
import { GetEndUserProfilesResponse } from '../model/getEndUserProfilesResponse';
import { GetForwardingNumberResponse } from '../model/getForwardingNumberResponse';
import { GetLoginFollowsTimeRoutingResponse } from '../model/getLoginFollowsTimeRoutingResponse';
import { GetModesResponse } from '../model/getModesResponse';
import { GetNoReplyTimeResponse } from '../model/getNoReplyTimeResponse';
import { GetPreferredLanguageResponse } from '../model/getPreferredLanguageResponse';
import { GetShowShortNumberResponse } from '../model/getShowShortNumberResponse';
import { GetSwitchboardNumberResponse } from '../model/getSwitchboardNumberResponse';
import { GetTimeRoutingActivatedForMobileResponse } from '../model/getTimeRoutingActivatedForMobileResponse';
import { GetTimeRoutingEnabledResponse } from '../model/getTimeRoutingEnabledResponse';
import { GetTimeRoutingResponse } from '../model/getTimeRoutingResponse';
import { GetWhitelistResponse } from '../model/getWhitelistResponse';
import { Mode } from '../model/mode';
import { NumberListEntry } from '../model/numberListEntry';
import { RemoveAbsenceWhitelistEntryResponse } from '../model/removeAbsenceWhitelistEntryResponse';
import { Response } from '../model/response';
import { SetAbsenceActivatedForMobile } from '../model/setAbsenceActivatedForMobile';
import { SetAbsenceSubscriptionResponse } from '../model/setAbsenceSubscriptionResponse';
import { SetAcdGroupNumberNumberResponse } from '../model/setAcdGroupNumberNumberResponse';
import { SetActiveProfileLeisureResponse } from '../model/setActiveProfileLeisureResponse';
import { SetActiveProfileResponse } from '../model/setActiveProfileResponse';
import { SetBlockedStatusResponse } from '../model/setBlockedStatusResponse';
import { SetCallbackEnabledResponse } from '../model/setCallbackEnabledResponse';
import { SetColleagueNumberResponse } from '../model/setColleagueNumberResponse';
import { SetCompanyDisplayNumberFollowsLoginResponse } from '../model/setCompanyDisplayNumberFollowsLoginResponse';
import { SetCompanyDisplayNumberFollowsTimeRoutingResponse } from '../model/setCompanyDisplayNumberFollowsTimeRoutingResponse';
import { SetCompanyDisplayNumberInternalResponse } from '../model/setCompanyDisplayNumberInternalResponse';
import { SetCompanyDisplayNumberResponse } from '../model/setCompanyDisplayNumberResponse';
import { SetDisplayNumberAfterWorkHoursResponse } from '../model/setDisplayNumberAfterWorkHoursResponse';
import { SetDisplayNumberResponse } from '../model/setDisplayNumberResponse';
import { SetForwardingNumberResponse } from '../model/setForwardingNumberResponse';
import { SetLoginFollowsTimeRoutingResponse } from '../model/setLoginFollowsTimeRoutingResponse';
import { SetModeResponse } from '../model/setModeResponse';
import { SetNoReplyTimeResponse } from '../model/setNoReplyTimeResponse';
import { SetSwitchboardNumberResponse } from '../model/setSwitchboardNumberResponse';
import { SetTimeRoutingActivatedForMobileResponse } from '../model/setTimeRoutingActivatedForMobileResponse';
import { SetTimeRoutingEnabledResponse } from '../model/setTimeRoutingEnabledResponse';
import { SetTimeRoutingResponse } from '../model/setTimeRoutingResponse';
import { SetWhitelistResponse } from '../model/setWhitelistResponse';
import { TimeRouting } from '../model/timeRouting';
import { WhitelistEntry } from '../model/whitelistEntry';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ConfigurationServiceInterface }                            from './configuration.serviceInterface';


@Injectable()
export class ConfigurationService implements ConfigurationServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe?: 'body', reportProgress?: boolean): Observable<AddAbsenceWhitelistEntryResponse>;
    public addAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddAbsenceWhitelistEntryResponse>>;
    public addAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddAbsenceWhitelistEntryResponse>>;
    public addAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AddAbsenceWhitelistEntryResponse>(`${this.basePath}/configuration/absenceWhitelist`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public addBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public addBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public addBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling addBlacklistEntry1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/configuration/blacklistentry/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public addCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public addCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public addCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling addCompanyBlacklistEntry1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/configuration/company/blacklistentry/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public addCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public addCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public addCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling addCompanyWhitelistEntry1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/configuration/company/whitelistentry/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe?: 'body', reportProgress?: boolean): Observable<AddWhitelistEntryResponse>;
    public addWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddWhitelistEntryResponse>>;
    public addWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddWhitelistEntryResponse>>;
    public addWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling addWhitelistEntry1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AddWhitelistEntryResponse>(`${this.basePath}/configuration/whitelistentry/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addWhitelistIncomingEntry1(organization?: string, login?: string, body?: WhitelistEntry, observe?: 'body', reportProgress?: boolean): Observable<AddWhitelistEntryResponse>;
    public addWhitelistIncomingEntry1(organization?: string, login?: string, body?: WhitelistEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddWhitelistEntryResponse>>;
    public addWhitelistIncomingEntry1(organization?: string, login?: string, body?: WhitelistEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddWhitelistEntryResponse>>;
    public addWhitelistIncomingEntry1(organization?: string, login?: string, body?: WhitelistEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AddWhitelistEntryResponse>(`${this.basePath}/configuration/whitelistentry`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param index 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public deleteBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public deleteBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public deleteBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling deleteBlacklistEntry1.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (index !== undefined && index !== null) {
            queryParameters = queryParameters.set('index', <any>index);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/configuration/blacklistentry/${encodeURIComponent(String(incoming))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param index 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public deleteCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public deleteCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public deleteCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling deleteCompanyBlacklistEntry1.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (index !== undefined && index !== null) {
            queryParameters = queryParameters.set('index', <any>index);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/configuration/company/blacklistentry/${encodeURIComponent(String(incoming))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param index 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public deleteCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public deleteCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public deleteCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling deleteCompanyWhitelistEntry1.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (index !== undefined && index !== null) {
            queryParameters = queryParameters.set('index', <any>index);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/configuration/company/whitelistentry/${encodeURIComponent(String(incoming))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param index 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'body', reportProgress?: boolean): Observable<DeleteWhitelistEntryResponse>;
    public deleteWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteWhitelistEntryResponse>>;
    public deleteWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteWhitelistEntryResponse>>;
    public deleteWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling deleteWhitelistEntry1.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (index !== undefined && index !== null) {
            queryParameters = queryParameters.set('index', <any>index);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<DeleteWhitelistEntryResponse>(`${this.basePath}/configuration/whitelistentry/${encodeURIComponent(String(incoming))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param index 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWhitelistIncomingEntry1(organization?: string, login?: string, index?: number, observe?: 'body', reportProgress?: boolean): Observable<DeleteWhitelistEntryResponse>;
    public deleteWhitelistIncomingEntry1(organization?: string, login?: string, index?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteWhitelistEntryResponse>>;
    public deleteWhitelistIncomingEntry1(organization?: string, login?: string, index?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteWhitelistEntryResponse>>;
    public deleteWhitelistIncomingEntry1(organization?: string, login?: string, index?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (index !== undefined && index !== null) {
            queryParameters = queryParameters.set('index', <any>index);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<DeleteWhitelistEntryResponse>(`${this.basePath}/configuration/whitelistentry`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceActivatedForMobile1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceActivatedForMobile>;
    public getAbsenceActivatedForMobile1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceActivatedForMobile>>;
    public getAbsenceActivatedForMobile1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceActivatedForMobile>>;
    public getAbsenceActivatedForMobile1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceActivatedForMobile>(`${this.basePath}/configuration/absenceActivatedForMobile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceSubscription1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceSubscriptionResponse>;
    public getAbsenceSubscription1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceSubscriptionResponse>>;
    public getAbsenceSubscription1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceSubscriptionResponse>>;
    public getAbsenceSubscription1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceSubscriptionResponse>(`${this.basePath}/configuration/absenceSubscription`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceWhitelist1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceWhitelistResponse>;
    public getAbsenceWhitelist1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceWhitelistResponse>>;
    public getAbsenceWhitelist1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceWhitelistResponse>>;
    public getAbsenceWhitelist1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceWhitelistResponse>(`${this.basePath}/configuration/absenceWhitelist`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAcdGroupNumberNumber1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAcdGroupNumberNumberResponse>;
    public getAcdGroupNumberNumber1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAcdGroupNumberNumberResponse>>;
    public getAcdGroupNumberNumber1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAcdGroupNumberNumberResponse>>;
    public getAcdGroupNumberNumber1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAcdGroupNumberNumberResponse>(`${this.basePath}/configuration/acdGroupNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveProfile1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetActiveProfileResponse>;
    public getActiveProfile1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetActiveProfileResponse>>;
    public getActiveProfile1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetActiveProfileResponse>>;
    public getActiveProfile1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetActiveProfileResponse>(`${this.basePath}/configuration/activeProfile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveProfileLeisure1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetActiveProfileLeisureResponse>;
    public getActiveProfileLeisure1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetActiveProfileLeisureResponse>>;
    public getActiveProfileLeisure1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetActiveProfileLeisureResponse>>;
    public getActiveProfileLeisure1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetActiveProfileLeisureResponse>(`${this.basePath}/configuration/activeProfileLeisure`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBlacklist1(incoming: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetBlacklistResponse>;
    public getBlacklist1(incoming: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetBlacklistResponse>>;
    public getBlacklist1(incoming: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetBlacklistResponse>>;
    public getBlacklist1(incoming: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling getBlacklist1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetBlacklistResponse>(`${this.basePath}/configuration/blacklist/${encodeURIComponent(String(incoming))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBlockedStatus1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetBlockedStatusResponse>;
    public getBlockedStatus1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetBlockedStatusResponse>>;
    public getBlockedStatus1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetBlockedStatusResponse>>;
    public getBlockedStatus1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetBlockedStatusResponse>(`${this.basePath}/configuration/blockedStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallbackEnabled1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCallbackEnabledResponse>;
    public getCallbackEnabled1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCallbackEnabledResponse>>;
    public getCallbackEnabled1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCallbackEnabledResponse>>;
    public getCallbackEnabled1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCallbackEnabledResponse>(`${this.basePath}/configuration/callbackEnabled`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getColleagueNumber1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetColleagueNumberResponse>;
    public getColleagueNumber1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetColleagueNumberResponse>>;
    public getColleagueNumber1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetColleagueNumberResponse>>;
    public getColleagueNumber1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetColleagueNumberResponse>(`${this.basePath}/configuration/colleagueNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetBlacklistResponse>;
    public getCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetBlacklistResponse>>;
    public getCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetBlacklistResponse>>;
    public getCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling getCompanyBlacklist1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetBlacklistResponse>(`${this.basePath}/configuration/company/blacklist/${encodeURIComponent(String(incoming))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyDisplayNumber1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCompanyDisplayNumberResponse>;
    public getCompanyDisplayNumber1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCompanyDisplayNumberResponse>>;
    public getCompanyDisplayNumber1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCompanyDisplayNumberResponse>>;
    public getCompanyDisplayNumber1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCompanyDisplayNumberResponse>(`${this.basePath}/configuration/companyDisplayNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyDisplayNumberFollowsLogin1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCompanyDisplayNumberFollowsLoginResponse>;
    public getCompanyDisplayNumberFollowsLogin1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCompanyDisplayNumberFollowsLoginResponse>>;
    public getCompanyDisplayNumberFollowsLogin1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCompanyDisplayNumberFollowsLoginResponse>>;
    public getCompanyDisplayNumberFollowsLogin1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCompanyDisplayNumberFollowsLoginResponse>(`${this.basePath}/configuration/companyDisplayNumberFollowsLogin`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyDisplayNumberFollowsTimeRouting1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCompanyDisplayNumberFollowsTimeRoutingResponse>;
    public getCompanyDisplayNumberFollowsTimeRouting1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCompanyDisplayNumberFollowsTimeRoutingResponse>>;
    public getCompanyDisplayNumberFollowsTimeRouting1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCompanyDisplayNumberFollowsTimeRoutingResponse>>;
    public getCompanyDisplayNumberFollowsTimeRouting1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCompanyDisplayNumberFollowsTimeRoutingResponse>(`${this.basePath}/configuration/companyDisplayNumberFollowsTimeRouting`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyDisplayNumberInternal1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCompanyDisplayNumberInternalResponse>;
    public getCompanyDisplayNumberInternal1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCompanyDisplayNumberInternalResponse>>;
    public getCompanyDisplayNumberInternal1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCompanyDisplayNumberInternalResponse>>;
    public getCompanyDisplayNumberInternal1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCompanyDisplayNumberInternalResponse>(`${this.basePath}/configuration/companyDisplayNumberInternal`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param departmentId 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanySwitchboardNumber1(departmentId: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSwitchboardNumberResponse>;
    public getCompanySwitchboardNumber1(departmentId: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSwitchboardNumberResponse>>;
    public getCompanySwitchboardNumber1(departmentId: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSwitchboardNumberResponse>>;
    public getCompanySwitchboardNumber1(departmentId: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling getCompanySwitchboardNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetSwitchboardNumberResponse>(`${this.basePath}/configuration/companySwitchboardNumber/${encodeURIComponent(String(departmentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetWhitelistResponse>;
    public getCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetWhitelistResponse>>;
    public getCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetWhitelistResponse>>;
    public getCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling getCompanyWhitelist1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetWhitelistResponse>(`${this.basePath}/configuration/company/whitelist/${encodeURIComponent(String(incoming))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDisplayNumber1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetDisplayNumberResponse>;
    public getDisplayNumber1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetDisplayNumberResponse>>;
    public getDisplayNumber1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetDisplayNumberResponse>>;
    public getDisplayNumber1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetDisplayNumberResponse>(`${this.basePath}/configuration/displayNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDisplayNumberAfterWorkHours1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetDisplayNumberAfterWorkHoursResponse>;
    public getDisplayNumberAfterWorkHours1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetDisplayNumberAfterWorkHoursResponse>>;
    public getDisplayNumberAfterWorkHours1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetDisplayNumberAfterWorkHoursResponse>>;
    public getDisplayNumberAfterWorkHours1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetDisplayNumberAfterWorkHoursResponse>(`${this.basePath}/configuration/displayNumberClosed`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEndUserProfiles1(organization?: string, observe?: 'body', reportProgress?: boolean): Observable<GetEndUserProfilesResponse>;
    public getEndUserProfiles1(organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetEndUserProfilesResponse>>;
    public getEndUserProfiles1(organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetEndUserProfilesResponse>>;
    public getEndUserProfiles1(organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetEndUserProfilesResponse>(`${this.basePath}/configuration/enduserProfiles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getForwardingNumber1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetForwardingNumberResponse>;
    public getForwardingNumber1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetForwardingNumberResponse>>;
    public getForwardingNumber1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetForwardingNumberResponse>>;
    public getForwardingNumber1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetForwardingNumberResponse>(`${this.basePath}/configuration/forwardingNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLoginFollowsTimeRouting1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetLoginFollowsTimeRoutingResponse>;
    public getLoginFollowsTimeRouting1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetLoginFollowsTimeRoutingResponse>>;
    public getLoginFollowsTimeRouting1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetLoginFollowsTimeRoutingResponse>>;
    public getLoginFollowsTimeRouting1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetLoginFollowsTimeRoutingResponse>(`${this.basePath}/configuration/loginFollowsTimeRouting`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMode1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetModesResponse>;
    public getMode1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetModesResponse>>;
    public getMode1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetModesResponse>>;
    public getMode1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetModesResponse>(`${this.basePath}/configuration/mode`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getModes1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetModesResponse>;
    public getModes1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetModesResponse>>;
    public getModes1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetModesResponse>>;
    public getModes1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetModesResponse>(`${this.basePath}/configuration/modes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNoReplyTime1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetNoReplyTimeResponse>;
    public getNoReplyTime1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNoReplyTimeResponse>>;
    public getNoReplyTime1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNoReplyTimeResponse>>;
    public getNoReplyTime1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetNoReplyTimeResponse>(`${this.basePath}/configuration/noReplyTime`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPreferredLanguage1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetPreferredLanguageResponse>;
    public getPreferredLanguage1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPreferredLanguageResponse>>;
    public getPreferredLanguage1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPreferredLanguageResponse>>;
    public getPreferredLanguage1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetPreferredLanguageResponse>(`${this.basePath}/configuration/preferredLanguage`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getShowShortNumber1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetShowShortNumberResponse>;
    public getShowShortNumber1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetShowShortNumberResponse>>;
    public getShowShortNumber1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetShowShortNumberResponse>>;
    public getShowShortNumber1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetShowShortNumberResponse>(`${this.basePath}/configuration/showShortNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSwitchboardNumber1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSwitchboardNumberResponse>;
    public getSwitchboardNumber1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSwitchboardNumberResponse>>;
    public getSwitchboardNumber1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSwitchboardNumberResponse>>;
    public getSwitchboardNumber1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetSwitchboardNumberResponse>(`${this.basePath}/configuration/switchboardNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTimeRouting1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetTimeRoutingResponse>;
    public getTimeRouting1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetTimeRoutingResponse>>;
    public getTimeRouting1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetTimeRoutingResponse>>;
    public getTimeRouting1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetTimeRoutingResponse>(`${this.basePath}/configuration/timeRouting`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTimeRoutingActivatedForMobile1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetTimeRoutingActivatedForMobileResponse>;
    public getTimeRoutingActivatedForMobile1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetTimeRoutingActivatedForMobileResponse>>;
    public getTimeRoutingActivatedForMobile1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetTimeRoutingActivatedForMobileResponse>>;
    public getTimeRoutingActivatedForMobile1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetTimeRoutingActivatedForMobileResponse>(`${this.basePath}/configuration/timeRoutingActivatedForMobile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTimeRoutingEnabled1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetTimeRoutingEnabledResponse>;
    public getTimeRoutingEnabled1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetTimeRoutingEnabledResponse>>;
    public getTimeRoutingEnabled1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetTimeRoutingEnabledResponse>>;
    public getTimeRoutingEnabled1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetTimeRoutingEnabledResponse>(`${this.basePath}/configuration/timeRoutingEnabled`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWhitelist1(incoming: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetWhitelistResponse>;
    public getWhitelist1(incoming: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetWhitelistResponse>>;
    public getWhitelist1(incoming: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetWhitelistResponse>>;
    public getWhitelist1(incoming: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling getWhitelist1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetWhitelistResponse>(`${this.basePath}/configuration/whitelist/${encodeURIComponent(String(incoming))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWhitelistIncoming1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetWhitelistResponse>;
    public getWhitelistIncoming1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetWhitelistResponse>>;
    public getWhitelistIncoming1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetWhitelistResponse>>;
    public getWhitelistIncoming1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetWhitelistResponse>(`${this.basePath}/configuration/whitelist`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe?: 'body', reportProgress?: boolean): Observable<RemoveAbsenceWhitelistEntryResponse>;
    public removeAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveAbsenceWhitelistEntryResponse>>;
    public removeAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveAbsenceWhitelistEntryResponse>>;
    public removeAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveAbsenceWhitelistEntryResponse>(`${this.basePath}/configuration/ignored`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeAbsenceWhitelistEntryWithId1(id: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveAbsenceWhitelistEntryResponse>;
    public removeAbsenceWhitelistEntryWithId1(id: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveAbsenceWhitelistEntryResponse>>;
    public removeAbsenceWhitelistEntryWithId1(id: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveAbsenceWhitelistEntryResponse>>;
    public removeAbsenceWhitelistEntryWithId1(id: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeAbsenceWhitelistEntryWithId1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveAbsenceWhitelistEntryResponse>(`${this.basePath}/configuration/absenceWhitelist/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAbsenceActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetAbsenceActivatedForMobile>;
    public setAbsenceActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetAbsenceActivatedForMobile>>;
    public setAbsenceActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetAbsenceActivatedForMobile>>;
    public setAbsenceActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setAbsenceActivatedForMobile1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetAbsenceActivatedForMobile>(`${this.basePath}/configuration/absenceActivatedForMobile/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAbsenceSubscription1(organization?: string, login?: string, body?: boolean, observe?: 'body', reportProgress?: boolean): Observable<SetAbsenceSubscriptionResponse>;
    public setAbsenceSubscription1(organization?: string, login?: string, body?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetAbsenceSubscriptionResponse>>;
    public setAbsenceSubscription1(organization?: string, login?: string, body?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetAbsenceSubscriptionResponse>>;
    public setAbsenceSubscription1(organization?: string, login?: string, body?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetAbsenceSubscriptionResponse>(`${this.basePath}/configuration/absenceSubscription`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param acdGroupNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAcdGroupNumberNumber1(acdGroupNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetAcdGroupNumberNumberResponse>;
    public setAcdGroupNumberNumber1(acdGroupNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetAcdGroupNumberNumberResponse>>;
    public setAcdGroupNumberNumber1(acdGroupNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetAcdGroupNumberNumberResponse>>;
    public setAcdGroupNumberNumber1(acdGroupNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (acdGroupNumber === null || acdGroupNumber === undefined) {
            throw new Error('Required parameter acdGroupNumber was null or undefined when calling setAcdGroupNumberNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetAcdGroupNumberNumberResponse>(`${this.basePath}/configuration/acdGroupNumber/${encodeURIComponent(String(acdGroupNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param profile 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setActiveProfile1(profile: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetActiveProfileResponse>;
    public setActiveProfile1(profile: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetActiveProfileResponse>>;
    public setActiveProfile1(profile: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetActiveProfileResponse>>;
    public setActiveProfile1(profile: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (profile === null || profile === undefined) {
            throw new Error('Required parameter profile was null or undefined when calling setActiveProfile1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetActiveProfileResponse>(`${this.basePath}/configuration/activeProfile/${encodeURIComponent(String(profile))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param profile 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setActiveProfileLeisure1(profile: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetActiveProfileLeisureResponse>;
    public setActiveProfileLeisure1(profile: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetActiveProfileLeisureResponse>>;
    public setActiveProfileLeisure1(profile: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetActiveProfileLeisureResponse>>;
    public setActiveProfileLeisure1(profile: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (profile === null || profile === undefined) {
            throw new Error('Required parameter profile was null or undefined when calling setActiveProfileLeisure1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetActiveProfileLeisureResponse>(`${this.basePath}/configuration/activeProfileLeisure/${encodeURIComponent(String(profile))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling setBlacklist1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/configuration/blacklist/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setBlockedStatus1(organization?: string, login?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<SetBlockedStatusResponse>;
    public setBlockedStatus1(organization?: string, login?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetBlockedStatusResponse>>;
    public setBlockedStatus1(organization?: string, login?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetBlockedStatusResponse>>;
    public setBlockedStatus1(organization?: string, login?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetBlockedStatusResponse>(`${this.basePath}/configuration/blockedStatus`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCallbackEnabled1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetCallbackEnabledResponse>;
    public setCallbackEnabled1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetCallbackEnabledResponse>>;
    public setCallbackEnabled1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetCallbackEnabledResponse>>;
    public setCallbackEnabled1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setCallbackEnabled1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetCallbackEnabledResponse>(`${this.basePath}/configuration/callbackEnabled/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param colleagueNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setColleagueNumber1(colleagueNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetColleagueNumberResponse>;
    public setColleagueNumber1(colleagueNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetColleagueNumberResponse>>;
    public setColleagueNumber1(colleagueNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetColleagueNumberResponse>>;
    public setColleagueNumber1(colleagueNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (colleagueNumber === null || colleagueNumber === undefined) {
            throw new Error('Required parameter colleagueNumber was null or undefined when calling setColleagueNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetColleagueNumberResponse>(`${this.basePath}/configuration/colleagueNumber/${encodeURIComponent(String(colleagueNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling setCompanyBlacklist1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/configuration/company/blacklist/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param companyDisplayNumber 
     * @param shown 
     * @param auto 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCompanyDisplayNumber1(companyDisplayNumber: string, shown: boolean, auto: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetCompanyDisplayNumberResponse>;
    public setCompanyDisplayNumber1(companyDisplayNumber: string, shown: boolean, auto: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetCompanyDisplayNumberResponse>>;
    public setCompanyDisplayNumber1(companyDisplayNumber: string, shown: boolean, auto: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetCompanyDisplayNumberResponse>>;
    public setCompanyDisplayNumber1(companyDisplayNumber: string, shown: boolean, auto: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyDisplayNumber === null || companyDisplayNumber === undefined) {
            throw new Error('Required parameter companyDisplayNumber was null or undefined when calling setCompanyDisplayNumber1.');
        }

        if (shown === null || shown === undefined) {
            throw new Error('Required parameter shown was null or undefined when calling setCompanyDisplayNumber1.');
        }

        if (auto === null || auto === undefined) {
            throw new Error('Required parameter auto was null or undefined when calling setCompanyDisplayNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetCompanyDisplayNumberResponse>(`${this.basePath}/configuration/companyDisplayNumber/${encodeURIComponent(String(companyDisplayNumber))}/${encodeURIComponent(String(shown))}/${encodeURIComponent(String(auto))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCompanyDisplayNumberFollowsLogin1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetCompanyDisplayNumberFollowsLoginResponse>;
    public setCompanyDisplayNumberFollowsLogin1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetCompanyDisplayNumberFollowsLoginResponse>>;
    public setCompanyDisplayNumberFollowsLogin1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetCompanyDisplayNumberFollowsLoginResponse>>;
    public setCompanyDisplayNumberFollowsLogin1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setCompanyDisplayNumberFollowsLogin1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetCompanyDisplayNumberFollowsLoginResponse>(`${this.basePath}/configuration/companyDisplayNumberFollowsLogin/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCompanyDisplayNumberFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetCompanyDisplayNumberFollowsTimeRoutingResponse>;
    public setCompanyDisplayNumberFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetCompanyDisplayNumberFollowsTimeRoutingResponse>>;
    public setCompanyDisplayNumberFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetCompanyDisplayNumberFollowsTimeRoutingResponse>>;
    public setCompanyDisplayNumberFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setCompanyDisplayNumberFollowsTimeRouting1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetCompanyDisplayNumberFollowsTimeRoutingResponse>(`${this.basePath}/configuration/companyDisplayNumberFollowsTimeRouting/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCompanyDisplayNumberInternal1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetCompanyDisplayNumberInternalResponse>;
    public setCompanyDisplayNumberInternal1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetCompanyDisplayNumberInternalResponse>>;
    public setCompanyDisplayNumberInternal1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetCompanyDisplayNumberInternalResponse>>;
    public setCompanyDisplayNumberInternal1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setCompanyDisplayNumberInternal1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetCompanyDisplayNumberInternalResponse>(`${this.basePath}/configuration/companyDisplayNumberInternal/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param departmentId 
     * @param switchboardNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCompanySwitchboardNumber1(departmentId: number, switchboardNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetSwitchboardNumberResponse>;
    public setCompanySwitchboardNumber1(departmentId: number, switchboardNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetSwitchboardNumberResponse>>;
    public setCompanySwitchboardNumber1(departmentId: number, switchboardNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetSwitchboardNumberResponse>>;
    public setCompanySwitchboardNumber1(departmentId: number, switchboardNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (departmentId === null || departmentId === undefined) {
            throw new Error('Required parameter departmentId was null or undefined when calling setCompanySwitchboardNumber1.');
        }

        if (switchboardNumber === null || switchboardNumber === undefined) {
            throw new Error('Required parameter switchboardNumber was null or undefined when calling setCompanySwitchboardNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetSwitchboardNumberResponse>(`${this.basePath}/configuration/companySwitchboardNumber/${encodeURIComponent(String(departmentId))}/${encodeURIComponent(String(switchboardNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling setCompanyWhitelist1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/configuration/company/whitelist/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setDisplayNumber1(organization?: string, login?: string, body?: DisplayNumber, observe?: 'body', reportProgress?: boolean): Observable<SetDisplayNumberResponse>;
    public setDisplayNumber1(organization?: string, login?: string, body?: DisplayNumber, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetDisplayNumberResponse>>;
    public setDisplayNumber1(organization?: string, login?: string, body?: DisplayNumber, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetDisplayNumberResponse>>;
    public setDisplayNumber1(organization?: string, login?: string, body?: DisplayNumber, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetDisplayNumberResponse>(`${this.basePath}/configuration/displayNumber`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setDisplayNumberAfterWorkHours1(organization?: string, login?: string, body?: DisplayNumber, observe?: 'body', reportProgress?: boolean): Observable<SetDisplayNumberAfterWorkHoursResponse>;
    public setDisplayNumberAfterWorkHours1(organization?: string, login?: string, body?: DisplayNumber, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetDisplayNumberAfterWorkHoursResponse>>;
    public setDisplayNumberAfterWorkHours1(organization?: string, login?: string, body?: DisplayNumber, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetDisplayNumberAfterWorkHoursResponse>>;
    public setDisplayNumberAfterWorkHours1(organization?: string, login?: string, body?: DisplayNumber, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetDisplayNumberAfterWorkHoursResponse>(`${this.basePath}/configuration/displayNumberClosed`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param forwardingNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setForwardingNumber1(forwardingNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetForwardingNumberResponse>;
    public setForwardingNumber1(forwardingNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetForwardingNumberResponse>>;
    public setForwardingNumber1(forwardingNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetForwardingNumberResponse>>;
    public setForwardingNumber1(forwardingNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (forwardingNumber === null || forwardingNumber === undefined) {
            throw new Error('Required parameter forwardingNumber was null or undefined when calling setForwardingNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetForwardingNumberResponse>(`${this.basePath}/configuration/forwardingNumber/${encodeURIComponent(String(forwardingNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setLoginFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetLoginFollowsTimeRoutingResponse>;
    public setLoginFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetLoginFollowsTimeRoutingResponse>>;
    public setLoginFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetLoginFollowsTimeRoutingResponse>>;
    public setLoginFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setLoginFollowsTimeRouting1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetLoginFollowsTimeRoutingResponse>(`${this.basePath}/configuration/loginFollowsTimeRouting/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setMode1(organization?: string, login?: string, body?: Mode, observe?: 'body', reportProgress?: boolean): Observable<SetModeResponse>;
    public setMode1(organization?: string, login?: string, body?: Mode, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetModeResponse>>;
    public setMode1(organization?: string, login?: string, body?: Mode, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetModeResponse>>;
    public setMode1(organization?: string, login?: string, body?: Mode, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetModeResponse>(`${this.basePath}/configuration/mode`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param noReplyTime 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setNoReplyTime1(noReplyTime: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetNoReplyTimeResponse>;
    public setNoReplyTime1(noReplyTime: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetNoReplyTimeResponse>>;
    public setNoReplyTime1(noReplyTime: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetNoReplyTimeResponse>>;
    public setNoReplyTime1(noReplyTime: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (noReplyTime === null || noReplyTime === undefined) {
            throw new Error('Required parameter noReplyTime was null or undefined when calling setNoReplyTime1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetNoReplyTimeResponse>(`${this.basePath}/configuration/noReplyTime/${encodeURIComponent(String(noReplyTime))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPreferredLanguage1(organization?: string, login?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setPreferredLanguage1(organization?: string, login?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setPreferredLanguage1(organization?: string, login?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setPreferredLanguage1(organization?: string, login?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/configuration/preferredLanguage`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param showShortNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setShowShortNumber1(showShortNumber: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setShowShortNumber1(showShortNumber: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setShowShortNumber1(showShortNumber: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setShowShortNumber1(showShortNumber: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (showShortNumber === null || showShortNumber === undefined) {
            throw new Error('Required parameter showShortNumber was null or undefined when calling setShowShortNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/configuration/showShortNumber/${encodeURIComponent(String(showShortNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param switchboardNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setSwitchboardNumber1(switchboardNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetSwitchboardNumberResponse>;
    public setSwitchboardNumber1(switchboardNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetSwitchboardNumberResponse>>;
    public setSwitchboardNumber1(switchboardNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetSwitchboardNumberResponse>>;
    public setSwitchboardNumber1(switchboardNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (switchboardNumber === null || switchboardNumber === undefined) {
            throw new Error('Required parameter switchboardNumber was null or undefined when calling setSwitchboardNumber1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetSwitchboardNumberResponse>(`${this.basePath}/configuration/switchboardNumber/${encodeURIComponent(String(switchboardNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setTimeRouting1(organization?: string, login?: string, body?: TimeRouting, observe?: 'body', reportProgress?: boolean): Observable<SetTimeRoutingResponse>;
    public setTimeRouting1(organization?: string, login?: string, body?: TimeRouting, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetTimeRoutingResponse>>;
    public setTimeRouting1(organization?: string, login?: string, body?: TimeRouting, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetTimeRoutingResponse>>;
    public setTimeRouting1(organization?: string, login?: string, body?: TimeRouting, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetTimeRoutingResponse>(`${this.basePath}/configuration/timeRouting`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setTimeRoutingActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetTimeRoutingActivatedForMobileResponse>;
    public setTimeRoutingActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetTimeRoutingActivatedForMobileResponse>>;
    public setTimeRoutingActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetTimeRoutingActivatedForMobileResponse>>;
    public setTimeRoutingActivatedForMobile1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setTimeRoutingActivatedForMobile1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetTimeRoutingActivatedForMobileResponse>(`${this.basePath}/configuration/timeRoutingActivatedForMobile/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param enabled 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setTimeRoutingEnabled1(enabled: boolean, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<SetTimeRoutingEnabledResponse>;
    public setTimeRoutingEnabled1(enabled: boolean, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetTimeRoutingEnabledResponse>>;
    public setTimeRoutingEnabled1(enabled: boolean, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetTimeRoutingEnabledResponse>>;
    public setTimeRoutingEnabled1(enabled: boolean, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enabled === null || enabled === undefined) {
            throw new Error('Required parameter enabled was null or undefined when calling setTimeRoutingEnabled1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<SetTimeRoutingEnabledResponse>(`${this.basePath}/configuration/timeRoutingEnabled/${encodeURIComponent(String(enabled))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param incoming 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'body', reportProgress?: boolean): Observable<SetWhitelistResponse>;
    public setWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetWhitelistResponse>>;
    public setWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetWhitelistResponse>>;
    public setWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (incoming === null || incoming === undefined) {
            throw new Error('Required parameter incoming was null or undefined when calling setWhitelist1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetWhitelistResponse>(`${this.basePath}/configuration/whitelist/${encodeURIComponent(String(incoming))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setWhitelistIncoming1(organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'body', reportProgress?: boolean): Observable<SetWhitelistResponse>;
    public setWhitelistIncoming1(organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetWhitelistResponse>>;
    public setWhitelistIncoming1(organization?: string, login?: string, body?: Array<WhitelistEntry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetWhitelistResponse>>;
    public setWhitelistIncoming1(organization?: string, login?: string, body?: Array<WhitelistEntry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetWhitelistResponse>(`${this.basePath}/configuration/whitelist`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
